import { DefinedUseBaseQueryResult, useQuery } from '@tanstack/react-query'
import { MicroSite } from '../../../services/Microsite.types'
import { getPropertyMicroSite } from '../../../services/property-microsite/PropertyMicrositeService'
import { useAxios } from '../../useAxios'

export const PROPERTY_MICRO_SITE_QUERY_KEY = 'property-micro-site'

const usePropertyMicroSite = (slug: string, initialData?: MicroSite): DefinedUseBaseQueryResult<MicroSite> => {
    const axiosInstance = useAxios()

    return useQuery(
        [PROPERTY_MICRO_SITE_QUERY_KEY, slug],
        async () => {
            return getPropertyMicroSite(axiosInstance, slug)
        },
        { initialData }
    )
}

export default usePropertyMicroSite
